import { colors, DipseaContentfulAssets } from '@components/shared'
import type { BackgroundColorType } from '../../services/contentfulMarketingLandingPages'
import { landingPageBackgroundColor } from '../../services/contentfulMarketingLandingPages'

export type BackgroundType = {
  backgroundColor: string,
  backgroundImageUrl?: string,
  height?: number,
  width?: number
}

export function getBackground (
  name: BackgroundColorType,
  imageUrl: string | null | undefined
): BackgroundType {
  let backgroundImageUrl

  if (imageUrl) {
    backgroundImageUrl = `https:${imageUrl}`
  }

  switch (name) {
    case landingPageBackgroundColor.glow:
      if (!backgroundImageUrl) {
        backgroundImageUrl = DipseaContentfulAssets['dipsea_desktop_ourstory_background_glow.jpg']
      }
      return {
        backgroundColor: colors.orange,
        backgroundImageUrl,
        height: 2235,
        width: 4320
      }
    case landingPageBackgroundColor.dawn:
      if (!backgroundImageUrl) {
        backgroundImageUrl = DipseaContentfulAssets['Voice-Actor-Dawn.jpg']
      }
      return {
        backgroundColor: colors.violet,
        backgroundImageUrl,
        height: 2235,
        width: 4320
      }
    case landingPageBackgroundColor.dusk:
      if (!backgroundImageUrl) {
        backgroundImageUrl = DipseaContentfulAssets['Voice-Actor-Dusk.jpg']
      }
      return {
        backgroundColor: colors.midnightBlue,
        backgroundImageUrl,
        height: 2235,
        width: 4320
      }
    case landingPageBackgroundColor.sand:
      return { backgroundColor: colors.sand }
    default:
      return { backgroundColor: colors.midnightBlue }
  }
}
